<template>
    <v-container>
        <v-row class="d-flex justify-center white--text">
            <h1>Auditoria</h1>
        </v-row>
        <v-row class="d-flex justify-center">
            <v-card class="pa-4 mt-3" elevation="2" width="100%">
                <v-row class="d-flex justify-center mx-0">
                    <v-select v-model="electionIdSelected" :items="elecciones" label="Elecciones" id="id" item-value="id" item-text="description" :full-width="true" @change="onChangeElection"></v-select>
                </v-row>
                <v-row class="d-flex justify-center mx-0">
                    <v-select :items="uresList" label="Ures" id="id" item-text="ures_pred" :disabled="uresList.length === 0" ></v-select>
                </v-row>
            </v-card>
        </v-row>
        <v-row class="d-flex justify-center">
            <v-card class="pa-4 mt-3" elevation="2" width="100%">
                <v-card-title>Resultados</v-card-title>
            </v-card>
        </v-row>
        <v-row class="d-flex justify-center">
            <v-card class="pa-4 mt-3" elevation="2" width="100%">
                <v-card-title>Mesas</v-card-title>
            </v-card>
        </v-row>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'prep',
        computed: {
            ...mapGetters({
                'elecciones': 'elecciones/elecciones',
            }),
        },
        data: () => {
            return {
                electionIdSelected: '',
                uresSelected: '',
                uresList: [],
            }
        },
        methods: {
            onChangeElection: function(electionIdSelected) {
                this.uresList = [];
                this.uresSelected = '';
                if(electionIdSelected){
                    this.$store.dispatch('prep/getUresByIdElection', 
                    {election_id: electionIdSelected})
                    .then(res => {
                        console.log(res)
                        this.uresList = res;
                    });
                }
            }
        },
        created() {
            this.$store.dispatch('elecciones/getElecciones');
        },
    }
</script>

<style scoped>

</style>